import { sessionStore } from '@/store/session/SessionStoreModule'
import { TCWApiError, TCWBaseError, TCWSessionError } from '@/plugins/TCWBaseError'
import BaseComponent from '@/tcw/components/BaseComponent'
import {
  ApiErrorHandle,
  ApiGeneralSinglePayload,
  ApiGeneralPayload,
  ApiGeneralObjectArrayPayload
} from '@/tcw/api/types'
import Component from 'vue-class-component'
import { ERR_CODE_UNEXPECTED } from '../constant/ErrorCode'

/**
 * コンポーネント基底クラス
 */
@Component
export default class DataGetComponent<T = ApiGeneralPayload> extends BaseComponent {
  get apiPath(): string {
    return ''
  }
  get requestParams(): ApiGeneralSinglePayload {
    return {}
  }

  /**
   * 初期化処理
   */
  protected created(): void {
    this.init()
  }

  /**
   * 初期化処理
   */
  public async init(): Promise<void> {
    try {
      this.isLoading = true
      // セッションチェック
      console.log('checkSession')
      await this.checkSession()
      // 前処理
      console.log('beforeProc')
      await this.beforeProc()
      // フェッチ処理
      console.log('fetchData')
      await this.fetchData()
      // 後処理
      console.log('afterProc')
      await this.afterProc()
    } catch (e) {
      console.log('errorProc', e)
      if (e instanceof TCWBaseError) {
        await this.errorProc(e)
      }
    } finally {
      this.isLoading = false
    }
  }

  protected async beforeProc(): Promise<void> {
    //
  }
  protected async fetchData(): Promise<void> {
    const apiAgent = this.getWebApi()
    const response: T = await apiAgent.call<T>(this.apiPath, 'GET', this.requestParams)
    this.responseInitWebApi(response)
  }
  protected responseInitWebApi(response: T): void {
    console.debug(response)
  }
  protected async afterProc(): Promise<void> {
    //
  }

  /**
   * エラーハンドリング
   *
   * @param e エラー
   */
  protected async errorProc(e: TCWBaseError): Promise<void> {
    if (e instanceof TCWSessionError) {
      await this.handleSessionError()
      return
    }

    // APIエラーハンドリング
    if (e instanceof TCWApiError) {
      const hasError = await this.handleTcwApiError(e)
      if (hasError) {
        throw e
      }
    }

    await this.defaultErrorProc(e)
  }

  /**
   * API周りのエラーハンドリング処理
   * @param e APIエラー
   * @returns
   */
  protected async handleTcwApiError(e: TCWApiError): Promise<boolean> {
    if (this.handleApiError === null) {
      return false
    }

    const errorCode = e.getErrorCode()
    const handleProc = this.handleApiError[errorCode]
    if (!handleProc) {
      return false
    }
    console.log(`エラー処理：${errorCode}`)
    return await handleProc(e)
  }
  protected async handleSessionError(): Promise<void> {
    // セッションが切れている場合はストアをクリアする
    this.clearToken()
    sessionStore.clear()
    this.$tcw.message({
      type: 'error',
      message: 'セッションが切れました'
    })
  }
  protected get handleApiError(): ApiErrorHandle {
    return null
  }
  protected async defaultErrorProc(e: Error): Promise<void> {
    console.error(e)
    if (e instanceof TCWBaseError) {
      this.$tcw.$store.errors.setError(e)
    } else {
      const tcwError = new TCWBaseError(ERR_CODE_UNEXPECTED, '予期せぬエラー', e)
      this.$tcw.$store.errors.setError(tcwError)
    }
  }
}

export class ArrayDataGetComponent extends DataGetComponent<ApiGeneralObjectArrayPayload> {}
